import { render, staticRenderFns } from "./AsignaRepartidor.vue?vue&type=template&id=01926b5c&"
import script from "./AsignaRepartidor.vue?vue&type=script&lang=js&"
export * from "./AsignaRepartidor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports